import React from "react";
import { cn } from "src/shadcn/lib/utils";
import {
  Combobox as ShadcnCombobox,
  ComboboxInput as ShadcnComboboxInput,
  ComboboxContent as ShadcnComboboxContent,
  ComboboxList as ShadcnComboboxList,
  ComboboxItem as ShadcnComboboxItem,
  ComboboxGroup as ShadcnComboboxGroup,
  ComboboxLabel as ShadcnComboboxLabel,
  ComboboxCollection as ShadcnComboboxCollection,
  ComboboxEmpty as ShadcnComboboxEmpty,
  ComboboxSeparator as ShadcnComboboxSeparator,
  ComboboxChips as ShadcnComboboxChips,
  ComboboxChip as ShadcnComboboxChip,
  ComboboxChipsInput as ShadcnComboboxChipsInput,
  ComboboxTrigger as ShadcnComboboxTrigger,
  ComboboxValue as ShadcnComboboxValue,
  useComboboxAnchor,
} from "src/shadcn/components/combobox";

const Combobox = (props: React.ComponentProps<typeof ShadcnCombobox>) => (
  <ShadcnCombobox {...props} />
);

const ComboboxInput = (
  props: React.ComponentProps<typeof ShadcnComboboxInput>
) => <ShadcnComboboxInput {...props} />;

const ComboboxContent = (
  props: React.ComponentProps<typeof ShadcnComboboxContent>
) => <ShadcnComboboxContent {...props} />;

const ComboboxList = (
  props: React.ComponentProps<typeof ShadcnComboboxList>
) => <ShadcnComboboxList {...props} />;

const ComboboxItem = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnComboboxItem>) => (
  <ShadcnComboboxItem
    className={cn(
      "cursor-pointer not-data-[variant=destructive]:data-highlighted:**:text-inherit",
      className
    )}
    {...props}
  />
);

const ComboboxGroup = (
  props: React.ComponentProps<typeof ShadcnComboboxGroup>
) => <ShadcnComboboxGroup {...props} />;

const ComboboxLabel = (
  props: React.ComponentProps<typeof ShadcnComboboxLabel>
) => <ShadcnComboboxLabel {...props} />;

const ComboboxCollection = (
  props: React.ComponentProps<typeof ShadcnComboboxCollection>
) => <ShadcnComboboxCollection {...props} />;

const ComboboxEmpty = (
  props: React.ComponentProps<typeof ShadcnComboboxEmpty>
) => <ShadcnComboboxEmpty {...props} />;

const ComboboxSeparator = (
  props: React.ComponentProps<typeof ShadcnComboboxSeparator>
) => <ShadcnComboboxSeparator {...props} />;

const ComboboxChips = (
  props: React.ComponentProps<typeof ShadcnComboboxChips>
) => <ShadcnComboboxChips {...props} />;

const ComboboxChip = (
  props: React.ComponentProps<typeof ShadcnComboboxChip>
) => <ShadcnComboboxChip {...props} />;

const ComboboxChipsInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<typeof ShadcnComboboxChipsInput>
>((props, ref) => <ShadcnComboboxChipsInput ref={ref} {...props} />);

const ComboboxTrigger = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnComboboxTrigger>) => (
  <ShadcnComboboxTrigger
    className={cn("cursor-pointer", className)}
    {...props}
  />
);

const ComboboxValue = (
  props: React.ComponentProps<typeof ShadcnComboboxValue>
) => <ShadcnComboboxValue {...props} />;

export {
  Combobox,
  ComboboxInput,
  ComboboxContent,
  ComboboxList,
  ComboboxItem,
  ComboboxGroup,
  ComboboxLabel,
  ComboboxCollection,
  ComboboxEmpty,
  ComboboxSeparator,
  ComboboxChips,
  ComboboxChip,
  ComboboxChipsInput,
  ComboboxTrigger,
  ComboboxValue,
  useComboboxAnchor,
};
